import LabVerification from "./LabVerification";
import UnitVerification from "./UnitVerification";
import DoctorVerification from "./DoctorVerification";

import { useSelector } from "react-redux";
import { hasRequiredRole } from "helpers";
import { VerificationLayout } from "layouts";

export default function Verifications() {
  const { roles } = useSelector((state) => state.auth.userInfo);
  const isDoctor = hasRequiredRole(["doctor"], roles);
  const isLabManager = hasRequiredRole(["labManager"], roles);
  const isUnitManager = hasRequiredRole(["unitManager"], roles);

  if (isDoctor) {
    return (
      <VerificationLayout>
        <DoctorVerification />
      </VerificationLayout>
    );
  }

  if (isLabManager) {
    return (
      <VerificationLayout>
        <LabVerification />
      </VerificationLayout>
    );
  }

  if (isUnitManager) {
    return (
      <VerificationLayout>
        <UnitVerification />
      </VerificationLayout>
    );
  }

  return
}
